<footer [class]="customFooterClass">
  <div>
    <h1>{{ 'MAIN.POWERED_BY' | translate}}</h1>
    <img src="{{assetPath}}imgs/logo.svg" alt="Noggin logo">
  </div>
</footer>
